import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import DynamicBanner from "../../include/DynamicBanner";
import api from "../../../../api";

const FacultyShow = () => {
  const { lastslug } = useParams();
  const [facultyData, setFacultyData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      if (!lastslug) return;
      try {
        setLoading(true);
        const response = await api.get(`/api/faculty-show/${lastslug}`);
        if (response.data && response.data.status) {
          setFacultyData(response.data.data);
        }
      } catch (error) {
        console.error("API Fetch Error:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [lastslug]);

  // --- Helper for Image URLs ---
  const getImageUrl = (path) => {
    if (!path) return "/assets/images/dummy-img.png";
    if (path.startsWith("http")) return path;

    const BASE_URL = process.env.REACT_APP_API_URL;
    const cleanPath = path.startsWith("/") ? path.substring(1) : path;
    return `${BASE_URL}/public/${cleanPath}`;
  };

  const getImageUrl1 = (path) => {
    if (!path) return "/assets/images/dummy-img.png";
    if (path.startsWith("http")) return path;

    const cleanPath = path.startsWith("/") ? path.substring(1) : path;
    return `/${cleanPath}`;
  };

  if (loading)
    return <div className="text-center py-5">Loading Faculty Data...</div>;
  if (!facultyData)
    return <div className="text-center py-5">No Faculty Data Found</div>;

  // --- Process Banner Images ---
  const rawDesktop = facultyData.banner?.desktop_images?.[0];
  const rawMobile = facultyData.banner?.mobile_images?.[0];

  const bannerImage = getImageUrl1(rawDesktop);
  const bannerImageMobile = rawMobile ? getImageUrl1(rawMobile) : bannerImage;

  return (
    <>
      <DynamicBanner
        title={facultyData.banner?.heading || facultyData.title}
        bgImage={bannerImage}
        bgImageMobile={bannerImageMobile}
      />

      <section className="faculty_section">
        <div className="container">
          <div className="sec-title text-center">
            <h2>{facultyData.section_title || "Faculty Members"}</h2>
          </div>

          {facultyData.faculty_groups &&
          facultyData.faculty_groups.length > 0 ? (
            facultyData.faculty_groups.map((group, gIndex) => (
              <div key={gIndex} className="mb-5">
                <div className="d-flex justify-content-center">
                  <h3 className="faculty-role-heading mb-4">{group.title}</h3>
                </div>

                <div className="row d-flex justify-content-center">
                  {/* Using Object.values to map over members object */}
                  {group.members &&
                    Object.values(group.members).map((member, mIndex) => (
                      <div
                        className="col-lg-4 col-md-6 col-12 mb-5"
                        key={mIndex}
                      >
                        <div className="single-faculty-item text-center">
                          <div className="faculty-wrapper-alumni mb-3">
                            <img
                              className="img-fluid facluty-main-image"
                              src={getImageUrl(member.image)}
                              alt={member.name}
                              // UPDATED STYLES FOR CIRCLE IMAGE
                              style={{
                                width: "180px", // Fixed width
                                height: "180px", // Fixed height (same as width for square)
                                objectFit: "cover", // Ensures image fills the square without stretching
                                borderRadius: "50%", // Makes the square circular
                                margin: "0 auto", // Ensures it centers horizontally
                              }}
                            />
                          </div>
                          <h1 className="faculty-title">{member.name}</h1>
                          <p className="faculty-designation">
                            {member.designation || "Faculty Member"}
                          </p>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            ))
          ) : (
            <div className="text-center py-5">No faculty members found.</div>
          )}
        </div>
      </section>
    </>
  );
};

export default FacultyShow;
